import { roundPrice } from "../components/PriceRounding.jsx"
import convertCurrency from "./convertCurrency.js"

export const formatFetchedProduct = ({
	product,
	productCurrency,
	roundPrices,
	roundingNumber,
	shopCurrency,
	defaultVendor,
	publishByDefault,
	defaultTags,
	taxableByDefault,
	statusActiveByDefault,
}) => {
	let productTags = []

	if (!product.tags) {
		productTags = [...(defaultTags || [])]
	} else if (Array.isArray(product.tags)) {
		productTags = [...product.tags, ...(defaultTags || [])]
	} else if (product.tags.length > 0 && product.tags.split) {
		productTags = [...product.tags.split(", "), ...(defaultTags || [])]
	}

	const deduplicatedProductTags = []
	productTags.forEach((element) => {
		if (!deduplicatedProductTags.includes(element)) {
			deduplicatedProductTags.push(element)
		}
	})

	let convertedPriceVariants = product.variants?.map((v) => {
		return {
			...v,
			price:
				roundPrices && roundingNumber !== null && v?.price
					? roundPrice(
							convertCurrency(
								parseFloat(v.price),
								productCurrency,
								shopCurrency,
							),
							roundingNumber,
						).toFixed(2)
					: v?.price
						? convertCurrency(
								parseFloat(v.price),
								productCurrency,
								shopCurrency,
							).toFixed(2)
						: "",
			compareAtPrice:
				roundPrices && roundingNumber !== null && v?.compare_at_price
					? roundPrice(
							convertCurrency(
								parseFloat(v.compare_at_price),
								productCurrency,
								shopCurrency,
							),
							roundingNumber,
						).toFixed(2)
					: v?.compare_at_price
						? convertCurrency(
								parseFloat(v.compare_at_price),
								productCurrency,
								shopCurrency,
							).toFixed(2)
						: "",
		}
	})

	return {
		title: product.title,
		vendor: defaultVendor || product.vendor || "",
		descriptionHtml: product.body_html,
		tags: deduplicatedProductTags
			.filter((tag) => tag !== "")
			.filter((tag) => tag !== "Kopy" && tag !== "kopy")
			.slice(0, 250),
		status: statusActiveByDefault ? "ACTIVE" : "DRAFT",
		published: (statusActiveByDefault && publishByDefault) || false,
		variants: convertedPriceVariants
			.map((variant) => {
				return {
					price: parseFloat(variant.price),
					options: [
						variant.option1 || "",
						variant.option2 || "",
						variant.option3 || "",
					],
					compareAtPrice: parseFloat(variant.compareAtPrice),
					imageSrc:
						variant.imageSrc ||
						product.images.filter(
							(img) => img.id === variant.image_id,
						)?.[0]?.src ||
						"",
					imageId: variant.image_id,
					_id: variant.id,
					taxable: taxableByDefault,
					sku: variant.sku?.toString() || null,
				}
			})
			.slice(0, 250),
		options: product.options.slice(0, 250),
		images: product.images
			?.map((img) => {
				return {
					altText: img.alt || "",
					src: img.src,
					id: img.id,
				}
			})
			.slice(0, 250),
	}
}
